<script setup>
import { onMounted, computed, defineProps } from 'vue';
import { useStore } from 'vuex'
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat)

const props = defineProps({
  lgu_has_speed_violation: {
    type: Array,
    required: true,
  }
});

onMounted(()=>{
  getLaneList();
});

const store = useStore()

const lane_list = computed(() => store.state.trafficRecordComponent.lane_list);
const traffic_record = computed(() => store.state.trafficRecordComponent.traffic_record);
const selected_lane = computed({
  get:() => store.state.trafficRecordComponent.selected_lane,
  set:(val) => store.commit('trafficRecordComponent/SET_SELECTED_LANE',val)
});

const input_speed_limit = computed({
  get:() => store.state.trafficRecordComponent.input_speed_limit,
  set:(val) => store.commit('trafficRecordComponent/SET_INPUT_SPEED_LIMIT',val)
});

const getLaneList = () => store.dispatch('trafficRecordComponent/getLaneList');

const loading = computed(() => store.state.globals.loading);
</script>

<template>
    <div class="col-md-12 col-lg-6 col-xl-4 mb-0">
      <b-overlay :show="loading">
        <div class="card">
          <div class="card-body overflow-auto">
            <table class="table table-bordered table-sm table-light m-0">
              <tbody>
                <tr>
                  <th colspan="2" class="text-center">Details</th>
                </tr>
                <!-- <tr>
                  <td class="no-wrap">Filename</td>
                  <td>{{traffic_record && traffic_record.filename ? traffic_record.filename : 'n/a'}}</td>
                </tr> -->
                <tr>
                  <td class="no-wrap">Lane</td>
                  <td>
                    <!-- <span class="small opacity-75">{{traffic_record && traffic_record.lane ? traffic_record.lane : ''}} - text file value</span> -->
                    <select required class="form-select" v-model="selected_lane" disabled>
                      <option v-for="option in lane_list" :key="option.code" :value="option.code">
                        {{ option.label }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td class="no-wrap">Location</td>
                  <td>{{traffic_record && traffic_record.camera ? "[" + traffic_record.camera.lgu.abbreviation + "] - " + traffic_record.camera.camera_id + " - " + traffic_record.camera.location : 'n/a'}}</td>
                </tr>
                <!-- <tr>
                  <td class="no-wrap">Location Code</td>
                  <td>{{traffic_record && traffic_record.location_code ? traffic_record.location_code : 'n/a'}}</td>
                </tr> -->
                <tr v-if="props.lgu_has_speed_violation.includes(traffic_record.queue.lgu_id)">
                  <td class="no-wrap">Speed Limit</td>
                  <td>
                    <div class="input-group">
                      <input class="form-control" type="number" v-model="input_speed_limit" disabled>
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">km/h</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="props.lgu_has_speed_violation.includes(traffic_record.queue.lgu_id)">
                  <td class="no-wrap">Speed Limit Car</td>
                  <td>{{traffic_record && traffic_record.speed_limit_car ? traffic_record.speed_limit_car : 'n/a'}}</td>
                </tr>
                <tr v-if="props.lgu_has_speed_violation.includes(traffic_record.queue.lgu_id)">
                  <td class="no-wrap">Speed Limit Truck</td>
                  <td>{{traffic_record && traffic_record.speed_limit_truck ? traffic_record.speed_limit_truck : 'n/a'}}</td>
                </tr>
                <tr v-if="props.lgu_has_speed_violation.includes(traffic_record.queue.lgu_id)">
                  <td class="no-wrap">Speed Limit Units</td>
                  <td>{{traffic_record && traffic_record.speed_limit_units ? traffic_record.speed_limit_units : 'n/a'}}</td>
                </tr>
                <tr>
                  <td class="no-wrap">Timestamp</td>
                  <td>{{traffic_record && traffic_record.timestamp ? dayjs(traffic_record.timestamp).format('ddd, LL hh:mm:ss A') : 'n/a'}}</td>
                </tr>
                <tr v-if="props.lgu_has_speed_violation.includes(traffic_record.queue.lgu_id)">
                  <td class="no-wrap">Vehicle Speed</td>
                  <td>{{traffic_record && traffic_record.vehicle_speed ? traffic_record.vehicle_speed+'km/h' : 'n/a'}}</td>
                </tr>
                <tr v-if="props.lgu_has_speed_violation.includes(traffic_record.queue.lgu_id)">
                  <td class="no-wrap">Vehicle Speed Units</td>
                  <td>{{traffic_record && traffic_record.vehicle_speed_units ? traffic_record.vehicle_speed_units : 'n/a'}}</td>
                </tr>
                <tr v-if="props.lgu_has_speed_violation.includes(traffic_record.queue.lgu_id)">
                  <td class="no-wrap">Vehicle Speed Unrounded</td>
                  <td>{{traffic_record && traffic_record.vehicle_speed_unrounded ? traffic_record.vehicle_speed_unrounded : 'n/a'}}</td>

                </tr>
                <!-- <tr>
                  <td class="no-wrap">Vehicle Type</td>
                  <td>{{traffic_record && traffic_record.vehicle_type ? traffic_record.vehicle_type : 'n/a'}}</td>

                </tr> -->
                <!-- <tr>
                  <td class="no-wrap">Version</td>
                  <td>{{traffic_record && traffic_record.version ? traffic_record.version : 'n/a'}}</td>

                </tr>
                <tr>
                  <td class="no-wrap">Phase</td>
                  <td>{{traffic_record && traffic_record.phase ? traffic_record.xml_phase : 'n/a'}}</td>

                </tr>
                <tr>
                  <td class="no-wrap">Phase Change Time</td>
                  <td>{{traffic_record && traffic_record.phase_change_time ? traffic_record.phase_change_time : 'n/a'}}</td>

                </tr>
                <tr>
                  <td class="no-wrap">Minor Type</td>
                  <td>{{traffic_record && traffic_record.minor_type ? traffic_record.minor_type : ''}}</td>
                </tr> -->
              </tbody>
            </table>
          </div>
        </div>
      </b-overlay>
    </div>
</template>

<style scoped>
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
td{
  padding:5px;
}
</style>
